import { PaymentsPostPremiumIsSubscriedRequestData, PaymentsPostPremiumIsSubscriedRequestDto, PaymentsPostPremiumIsSubscriedResponseData, PaymentsPostPremiumIsSubscriedResponseDto } from '@services/dto/payments';
export const paymentsPostPremiumIsSubscriedRequestToDto = (data: PaymentsPostPremiumIsSubscriedRequestData): PaymentsPostPremiumIsSubscriedRequestDto => {
  return data;
};
export const paymentsPostPremiumIsSubscriedResponseFromDto = (dto: PaymentsPostPremiumIsSubscriedResponseDto): PaymentsPostPremiumIsSubscriedResponseData => {
  return dto.data;
};